import {
  EdgeLabelRenderer,
  getBezierPath,
  useInternalNode,
  useReactFlow,
  type EdgeProps,
} from "@xyflow/react";
import { getEdgeParams } from "../utils/initialElements";
import { FaTimes } from "react-icons/fa";
import { StyledDashedEdge, StyledEdgeArrowSvg } from "./index.styled";

export default function DashedEdge({ id, source, target }: EdgeProps) {
  const { setEdges } = useReactFlow();

  const sourceNode = useInternalNode(source);
  const targetNode = useInternalNode(target);

  if (!sourceNode || !targetNode) {
    return null;
  }

  const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(
    sourceNode,
    targetNode,
  );

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: tx,
    targetY: ty,
  });

  const customMarkerEnd = "url(#arrow-end)";
  const customMarkerStart = "url(#arrow-start)";

  return (
    <>
      <StyledEdgeArrowSvg>
        <defs>
          <marker
            id="arrow-end"
            viewBox="0 0 10 10"
            refX="20"
            refY="5"
            markerWidth="14"
            markerHeight="14"
            orient="auto"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" />
          </marker>
          <marker
            id="arrow-start"
            viewBox="0 0 10 10"
            refX="-10"
            refY="5"
            markerWidth="14"
            markerHeight="14"
            orient="auto"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" />
          </marker>
        </defs>
      </StyledEdgeArrowSvg>

      <StyledDashedEdge
        id={id}
        path={edgePath}
        // style={{
        //   strokeDasharray: "4 3",
        //   animation: "dashdraw 0.5s linear infinite",
        //   strokeWidth: 1,
        // }}
        markerEnd={customMarkerEnd}
        markerStart={customMarkerStart}
      />

      <EdgeLabelRenderer>
        <FaTimes
          size={12}
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
            color: "red",
            zIndex: 1000,
            cursor: "pointer",
          }}
          className="nodrag nopan"
          onClick={() => {
            setEdges((es) => es.filter((e) => e.id !== id));
          }}
        />
      </EdgeLabelRenderer>
      <style>
        {`
          @keyframes dashdraw {
            from {
              stroke-dashoffset: 5;
            }
          }
        `}
      </style>
    </>
  );
}
